<template lang="">
  <div>
    <div class="container">
      <div class="main-result">
        <Form :model="formItem" :label-width="80">
          <FormItem label="企业代码">
            <Input
              @click="SelectClientSwitch = !SelectClientSwitch"
              v-model="formItem.clientCode"
              type="text"
              placeholder="企业代码"
            ></Input>
          </FormItem>

          <FormItem label="仓库代号">
            <Input
              v-model="formItem.store_code"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="仓库代号"
            ></Input>
          </FormItem>

          <FormItem label="仓库名称">
            <Input
              v-model="formItem.store_name"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="仓库名称"
            ></Input>
          </FormItem>

          <FormItem label="备注">
            <Input
              v-model="formItem.remark"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="多次查询回复..."
            ></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="updatas()">提交</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { updataStorasList } from "@/api/index";
export default {
  data() {
    return {
      formItem: {
        clientCode: "",
        store_code: "",
        store_name: "",
        remark: "",
        id: 0,
      },
    };
  },
  props: ["ResultDate"],
  components: {},
  beforeCreate() { },
  mounted() { },
  updated() { },
  watch: {
    ResultDate(news, olds) {
      this.formItem = {
        clientCode: news.clientCode,
        store_code: news.store_code,
        store_name: news.store_name,
        remark: news.remark,
        id: news.id,
      };
    },
  },
  methods: {
    updatas() {
      updataStorasList({
        obj: this.formItem
      }).then((res) => {
        if (res) {
          this.$emit("resultDates", this.formItem);
        }
      });
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;

}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: left;

}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
